// extracted by mini-css-extract-plugin
export default {"Container":"Research_Container__sMpFz","ResearchItem2":"Research_ResearchItem2__1jQo4","ResearchItem":"Research_ResearchItem__g9qFt"};